/**
 * @module lib/ocean
 * Utilities for communicating with Ocean servers
 * You probably don't want to use these functions directly
 * @see {@link module:lib/appserver/request} for appserver API utilities
 */

import * as ajax from "lib/ajax";

/**
 * Make an ajax request to a ocean/longiframe_ajax api. oceanExecute wannabe!
 * NOTE: all requests are public, so these request strings need to be whitelisted in config
 *
 * @param {string} hostname hostname of target server
 * @param  {Object} jspCmd
 * @param  {Object} [jspArgs]
 * @param {Object} [requestOptions] passed to {@link module:lib/ajax~request}
 * @returns {Promise}
 */
export function jspCmdRequest(hostname, jspCmd, jspArgs = {}, requestOptions) {
  const data = buildQueryString({
    jspCmd: jspCmd,
    jspArgs: buildQueryString(jspArgs)
  });
  return ajax.request(`https://${hostname}/system/clientJSP/longiframe_ajax.html.nc`, data, requestOptions);
}

/**
 * Make an AJAX request to an API endpoint.
 * NOTE: all requests are public, so these request strings need to be whitelisted in config
 *
 * @param  {Object} url full URL of target endpoint, including hostname and path
 * @param  {Object} [args] key-value pairs to pass as query string params
 * @param {Object} [requestOptions] passed to {@link module:lib/ajax~request}
 * @returns {Promise}
 */
export function apiRequest(url, args, requestOptions) {
  return ajax.request(url, buildQueryString(args), requestOptions);
}

/**
 * Encode a string for use in a URL
 * Differs from encodeURIComponent by using ASCII instead of UTF-8 encoding
 * This is required since the backend doesn't properly decode UTF-8
 *
 * @returns {string}
 */
function encodeQueryStringComponent(inputString) {
  return encodeURIComponent(inputString)
}

/**
 * Wrap lib/ajax's buildQueryString to pass in our
 *   ocean-specific encoding.
 */
function buildQueryString(queryArgs) {
  return ajax.buildQueryString(queryArgs, encodeQueryStringComponent);
}



// WEBPACK FOOTER //
// ./src/lib/ocean/index.js